import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  StageBarDiv,
  StageBarItemDiv,
  StageBarDesignDiv,
  StageBarCircle,
  StageBarText,
  StageBarLine,
  ButtonsDiv,
  ButtonDiv,
  ButtonImage,
  ButtonText,
  DisabledButtonDiv,
  DisabledButtonImage,
  DisabledButtonText,
  LoadingMessage
} from './style'
import { OrdersDetailsDTO } from '../../../types/orders/orders-details'
import ModalContext from '../../../contexts/ModalContext'
import OrdersContext from '../../../contexts/OrdersContext'
import cross from '../../../assets/orders/cross.svg'
import activeFile from '../../../assets/orders/file-active.svg'
import activeCert from '../../../assets/orders/certificate-active.svg'
import file from '../../../assets/orders/file.svg'
import cert from '../../../assets/orders/certificate.svg'
import LoadingGif from '../../../assets/loading'
import SimpleDropdown from '../../SimpleDropdown'
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu'
import CertificateDropdown from '../DropdownCertificates'
interface StatusTable {
  [key: number]: number
}

const OrdersDetails: React.FC = () => {
  const { orderId, originDealId, status, statusId } = useContext(OrdersContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const [loading, setLoading] = useState(true)
  const [details, setDetails] = useState<OrdersDetailsDTO>()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setLoading(true)
    const url = process.env.REACT_APP_ORDERS_BASE_URL
    axios
      .post(`https://ploomes-orders-hjk3p7rq3q-rj.a.run.app/orders-by-ploomes/details`,
        {
          id: orderId,
          originDealId: originDealId
        }
      )
      .then((response) => {
        setDetails(response.data)
      })
      .catch((error) => {
        console.log('Ocorreu um erro ao obter os dados dos pedidos', error)
        alert("Erro desconhecido ao carregar os detalhes!")
      })
      .finally(() => {
        setLoading(false)
      })
  }, [orderId])

  const DropdownMenu = () => {

    if (!isOpen) {
      return null;
    }
    return (
      <CertificateDropdown documents={details ? details.documents: []}/>
    )
  };
  const stageMap: StatusTable = {
    10052601: 0, //Pedido ganho
    50004575: 0,//Pedido desmembrado
    50004000: 0,//Aguardando Corte
    10052602: 1,//Corte em execução
    50003998: 1,//Aguardando forja
    10052603: 2,//Forjando
    50002534: 2,//Inspeção pós forjamento
    50004218: 2, //Aguardando corte secundário
    10092479: 3,//Corte secundário
    50003999: 3,//Aguardando usinagem
    50002532: 3,//Usinagem em execução
    10063989: 4,//Enviar p/ terceiros
    10052689: 5,//Em terceiros
    50004775: 5,//Aguardando relatório de terceiros
    50003813: 5,///Levar amanhã
    50005340: 5, //Aguardando Certificado de Qualidade
    50003804: 5,//Separação e inspeção final
    10053355: 6,//Emissão NF
    50001470: 7,//Expedição
    10053356: 8,//Entregue/Coletado
    50004576: 8,//Produtos desmembrados finalizados
  }


  const currentStage = stageMap[statusId]

  const stages: string[] = ['Pedido recebido', 'Corte em Execução', 'Forjando', 'Corte secundário',
    'Enviar p/ terceiros', 'Em terceiros', 'Emissão NF', 'Expedição', 'Entregue /Coletado'
  ]

const iconDrop = document.querySelector('.Luis');

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Pedido: </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <StageBarDiv>
        {stages.map((stage, index) => (
          <StageBarItemDiv key={stage}>
            <StageBarDesignDiv className={index == 8 ? 'lastCircle' : ''}>
              <StageBarCircle className={index <= currentStage ? 'active' : ''} />
              {index < 8 && <StageBarLine
                className={index <= currentStage - 1 ? 'active' : ''}
              />}
            </StageBarDesignDiv>
            <StageBarText
              className={
                index == 0 ? 'first' :
                  index == 8 ? 'last' : ''
              }
            >{stage}</StageBarText>
          </StageBarItemDiv>
        ))}
      </StageBarDiv>
      {/* {loading ?
        <LoadingMessage>
          <img src={LoadingGif}></img>
        </LoadingMessage> */} :
        <ButtonsDiv>
          {details?.invoice?.xmlArray?.length !== 0 && details?.invoice?.xmlArray?.length !== undefined ?
            <a href={details.invoice.xmlArray[0]} target="_blank" rel="noreferrer">
              <ButtonDiv className='xmlButton'>
                <ButtonImage src={activeFile} alt='Right arrow icon' className='xmlImg' />
                <ButtonText className='xmlText'>Xml</ButtonText>
              </ButtonDiv>
            </a> :
            <DisabledButtonDiv className='xmlButton'>
              <DisabledButtonImage src={file} alt='Right arrow icon' className='xmlImg' />
              <DisabledButtonText className='xmlText'>Xml</DisabledButtonText>
            </DisabledButtonDiv>
          }

          {details?.invoice?.danfeArray?.length !== 0 && details?.invoice?.danfeArray?.length !== undefined ?

            <a href={details.invoice.danfeArray[0]} target="_blank" rel="noreferrer">
              <ButtonDiv className='nfButton'>
                <ButtonImage src={activeFile} alt='Right arrow icon' className='nfImg' />
                <ButtonText className='nfText'>Nota fiscal</ButtonText>
              </ButtonDiv>
            </a> 
            
            :

            <DisabledButtonDiv className='nfButton'>
              <DisabledButtonImage src={file} alt='Right arrow icon' className='nfImg' />
              <DisabledButtonText className='nfText'>Nota fiscal</DisabledButtonText>
            </DisabledButtonDiv>
          }
          {details?.documents?.length !== 0 && details?.documents?.length !== undefined ?

          
            <>
            {details?.documents?.length > 1  ?
            
               <ButtonDiv onClick={()=>{
                setIsOpen(!isOpen)
               }} style={{ width: '12vw'}}>
              <DropdownMenu />
              <ButtonImage  src={activeCert} alt='Right arrow icon' className='certImg' />
              <ButtonText className='certText'>Certificados</ButtonText>
              <SimpleDropdown
                className=''
                isOpen={isOpen}
                onChange={() => setIsOpen(!isOpen)}
              />
            </ButtonDiv>

              : 
              
              <a href={details.documents[0]} target="_blank" rel="noreferrer">
              <ButtonDiv>
                <ButtonImage src={activeCert} alt='Right arrow icon' className='certImg' />
                <ButtonText className='certText'>Certificado</ButtonText>
              </ButtonDiv>
            </a> 
          }
            </>

            :

            <DisabledButtonDiv>
                <DisabledButtonImage src={cert} alt='Right arrow icon' className='certImg'/>
                <DisabledButtonText className='certText'>Certificados</DisabledButtonText>
            </DisabledButtonDiv>

          }

        </ButtonsDiv>
      {/* } */}
    </Container>
  )
}

export default OrdersDetails